import background from './background.mjs'
import {
  imgproxySettings,
  mobileImgproxySettings,
  resolvePaceOptionsFromSKU as resolveOptionsFromSKU,
  getSKUWithoutPrefix,
  stripMatteOrInfinitePrefix,
} from './shared.mjs'

import { frame, nose, earsocks, icons, reflection } from './vulcans.mjs'

export const lenses = {
  id: 'lens',
  name: 'Lenses',
  imgproxySettings,
  mobileImgproxySettings,
  options: {
    v_IRsmokeTF: {
      pathTemplate: 'gs://sg360/260318/vcle_v_8IRsmoke--{nnn}.png',
    },
    v_IRhvblueTF: {
      pathTemplate: 'gs://sg360/260318/vcle_v_8IRhvblue--{nnn}.png',
    },
    v_IRgoldTF: {
      pathTemplate: 'gs://sg360/260903/vcle_v_8IRgold--{nnn}.png',
    },
    v_silverblueTF: {
      pathTemplate: 'gs://sg360/260318/vcle_v_8silverblue--{nnn}.png',
    },
    v_plumTF: {
      pathTemplate: 'gs://sg360/260903/vcle_v_8plum--{nnn}.png',
    },
  },
}

export const iris = {
  id: 'iris',
  name: 'Iris Mask',
  imgproxySettings,
  mobileImgproxySettings,
  isIrisMask: true,
  options: {
    none: {
      disabled: true,
    },
    v_IRsmokeTF: {
      pathTemplate: 'gs://sg360/260318/vcle_v_8IRsmoke--{nnn}_overlay.png',
      maxOpacity: 1,
    },
    v_IRhvblueTF: {
      pathTemplate: 'gs://sg360/260318/vcle_v_8IRhvblue--{nnn}_overlay.png',
      maxOpacity: 1,
    },
    v_IRgoldTF: {
      pathTemplate: 'gs://sg360/260903/vcle_v_8IRgold--{nnn}-overlay.png',
      maxOpacity: 1,
    },
  },
}

function resolveOptions(customisedProduct) {
  const options = {
    frame: stripMatteOrInfinitePrefix(getSKUWithoutPrefix(customisedProduct.frameChoice?.sku)),
    nose: stripMatteOrInfinitePrefix(getSKUWithoutPrefix(customisedProduct.noseChoice?.sku) || 'none'),
    icons: getSKUWithoutPrefix(customisedProduct.iconChoice.sku),
    engraving: 'eN',
    earsocks: getSKUWithoutPrefix(customisedProduct.earsocksChoice.sku),
    lens:
      getSKUWithoutPrefix(customisedProduct.lensChoice.skuWithoutLensTech) +
      customisedProduct.frameType.toUpperCase(),
    iris:
      getSKUWithoutPrefix(customisedProduct.lensChoice.skuWithoutLensTech) +
      customisedProduct.frameType.toUpperCase(),
    reflections: 'r5pc' + customisedProduct.frameType.toUpperCase(),
  }

  return options
}

function resolveSecondaryOptions(customisedProduct) {
  const options = {
    bottom: stripMatteOrInfinitePrefix(getSKUWithoutPrefix(customisedProduct.bottomChoice?.sku) || 'none'),
    nose: stripMatteOrInfinitePrefix(getSKUWithoutPrefix(customisedProduct.noseChoice?.sku) || 'none'),
  }

  if (customisedProduct.frameType === 'tf') delete options.nose
  if (customisedProduct.frameType === 'ff') delete options.bottom

  return options
}

export default {
  supports360: false,
  layers: [background, frame, earsocks, nose, icons, lenses, iris, reflection],
  resolveOptions,
  resolveSecondaryOptions,
  resolveOptionsFromSKU,
}
